module.exports = __webpack_public_path__ + "img/rage-of-the-sea.0b6c0836.jpg";